import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IconNames } from '../icons/icon-names';

@Component({
  selector: 'app-svg-template',
  templateUrl: './svg-template.component.html',
  styleUrls: ['./svg-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgTemplateComponent {
  private readonly sanitizer = inject(DomSanitizer);

  /** Icon fill colour (optional, default: white) */
  focusFillColour = input<'blue' | 'white'>('white');

  /** Icon name (required) */
  iconName = input<IconNames>();

  /** Custom svg width (optional, default: 32) */
  width = input<string>('32');

  /** Custom svg height (optional, default: 32) */
  height = input<string>('32');

  /** Custom viewbox dimensions (optional, default: 0 0 32 32) */
  customViewBox = input<string>('0 0 32 32');

  /** The title ref for the svg. Please match to the title
   * set within the icon name being used (required, important for accessibility) */
  title = input<string>();

  public get viewBox(): string {
    return this.customViewBox();
  }

  public get icon(): SafeHtml {
    const icon = this.iconName();
    const pathString = icon ? icon.toString() : '';
    return this.sanitizer.bypassSecurityTrustHtml(pathString);
  }
}
